import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  handleUpdateGeos: (e: { value: string | number; label: string }[]) => void;
  selectedGeos: { value: string | number; label: string }[];
  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;
  selectedActive: { value: string | number; label: string }[];
  handleApply: () => void;
}
const PromoFilterList: React.FC<Props> = ({
  searchValue,
  handleSearch,
  handleUpdateGeos,
  selectedGeos,
  handleApply,
  selectedActive,
  handleUpdateActive,
}) => {
  const { t } = useTranslation();
  const geoList = useAppSelector((state) => state.settings.geoList);
  const [geos, setGeos] = useState<{ value: string | number; label: string }[]>(
    []
  );

  useEffect(() => {
    const result = geoList.map((el) => {
      return {
        value: el,
        label: el,
      };
    });
    setGeos(result);
  }, [geoList]);

  const handleApplyGeos = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    handleUpdateGeos(isDelete ? e : [...selectedGeos, ...e]);
  };

  const handleApplyActive = (
    e: { value: string | number; label: string }[]
  ) => {
    handleUpdateActive(e);
  };
  const handleClearFilters = () => {
    handleUpdateGeos([]);
    handleSearch("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
          inputPlaceholder: t("title"),
          inputType: "text",
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: selectedActive,
          handleApply: handleApplyActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: "GEO",
          boxTitle: t("filterGeos"),
          icon: gridIcon,
          itemsArray: geos,
          activeItems: selectedGeos,
          handleApply: handleApplyGeos,
          disabled: geos.length === 0,
        },
      ]}
    />
  );
};

export default PromoFilterList;
